<template>
  <div class="usdt_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/user')"
      />
      <div class="big_tit">
        {{ data.payment.name }}
      </div>
    </div>
    <div class="code_box">
      <div class="money">
        <!--{{$t('utils.moneyMark')}}-->{{ money }}
      </div>
      <div v-if="data.payment.type==1">
        {{ $t('invest_qrcode.scanQRcode') }}
      </div>
			
      <div class="qrcode_img">
        <div
          ref="qrCodeUrl"
          class="qrcode"
        />
      </div>
      <div
        v-if="data.payment.type==1"
        class="wallet"
      >
        {{ $t('invest_qrcode.walletAddress') }}
      </div>
      <div
        v-if="data.payment.type==1"
        class="walletAddress"
      >
        {{ address }}
      </div>
    </div>
    <div
      v-if="data.payment.type==1"
      class="button_box"
    >
      <div
        v-clipboard="() => address"
        v-clipboard:success="copy"
        class="copy_link"
        @click="copyAddress"
      >
        {{ $t('invest_qrcode.copyWalletAddress') }}
      </div>
    </div>
    
    <div
      v-if="data.auto_recharge==0"
      class="voucher"
    >
      <van-field
        name="fileList"
        :label="$t('invest_qrcode.voucher')"
      >
        <template #input>
          <van-uploader
            v-model="fileList"
            multiple
            :max-count="1"
            class="upload"
            :max-size="2 * 1024 * 1024"
            :after-read="afterRead"
            :before-read="beforeRead"
            @oversize="onOversize"
          />
        </template>
      </van-field>
    </div>
    <p class="canal_tips">
      {{ $t('invest_bank.bank') }}
    </p>
    <div
      class="basic_btn"
      @click="submitBtn"
    >
      {{ $t('utils.submit') }}
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import bsHeader from '../../components/bsHeader.vue'
	import Clipboard from 'v-clipboard';
	import QRCode from 'qrcodejs2'
	import {
	    Overlay,Uploader,Field,Toast
	} from 'vant';
	import axios from 'axios'
	Vue.use(Clipboard).use(Uploader).use(Field);
    export default {
        name: "InvestQrcode",
        data() {
            return {
                data: {},
				fileList: [],
                money: 0,
				voucher:"",
				auto_recharge:1,
				address:'222222'
            };
        },
        created() {
			
            this.$parent.footer('user', false);
			
        },
        mounted() {
            this.money = this.$route.query.money;
            this.start();
			 let _this=this;
			  
			setTimeout(function(){
				_this.creatQrCode(_this.address);
			},2000);
        },
        methods: {
			  creatQrCode(text) {
				 
				var qrcode = new QRCode(this.$refs.qrCodeUrl, {
					text: text,  
					width: 200,
					height: 200,
					colorDark: '#000000',
					colorLight: '#ffffff',
					correctLevel: QRCode.CorrectLevel.H
				})
			},
            start() {
            	Fetch('/user/recharge_type', {
            		money: this.$route.query.money ? this.$route.query.money : "",
					id:this.$route.query.id ? this.$route.query.id : ""
            	}).then((r) => {
            		this.data = r.data;
					//console.log(this.data.user.tron_address);
					if(r.data.auto_recharge){
                         this.address=this.data.user.tron_address;
					}else{
						this.address=this.data.payment.address;
					}
					
					this.auto_recharge=r.data.auto_recharge;
            	});
            },
            submitBtn(){
				if(this.auto_recharge){
                   this.$router.replace("/moneybag");
				}else{

				if(this.voucher==""){
					this.$toast(this.$t('invest_qrcode.voucherEmpty'));
					return false;
				}
				Fetch("/user/recharge_apply", {
					id: this.data.orderId,
					voucher:this.voucher
				}).then((r) => {
					if (r.code == 1) {
						this.$toast({
							background: "#07c160",
							message: this.$t('invest_qrcode.submittedSuccessfully'),
						});
						this.$router.replace("/moneybag");
					}
				});
				}
				
			 
			},
			copyAddress() {
			    this.mask_show = true;
			    var that = this;
			    var local = window.location.origin;
			    var url = local + this.data.down_image;
			},
			copy() {
			    this.$toast({
			        background: '#07c160',
			        message: this.$t('invest_qrcode.copySucceeded')
			    })
			},
			onOversize(file) {
			    this.$toast(this.$t('account.within2megabytes'));
			},
			beforeRead(file) {
			    if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
			        this.$toast(this.$t('account.supportPicture'));
			        return false;
			    }
			    return true;
			},
			afterRead(file) {
			    let formData = new FormData();
				formData.append('language', this.$i18n.locale||"zh_cn");
			    formData.append('file', file.file);
			    formData.append('id', this.$router.history.current.params.id);
				formData.append('token', localStorage.getItem('token'));
				Toast.loading({
					forbidClick: true,
					duration: 20000
				});
			    axios.post(Api.commonUrl+"/api/index/bank_link_upload", formData).then((r) => {
					Toast.clear();
					if (r.data.code === 1) {
						this.voucher = r.data.data;
			        } else {
			            if (r.data.info) {
			                this.$toast(r.data.info);
			            } else {
			                this.$toast(this.$t('account.uploadFail'));
			            }
			        }
			    });
			}
        }
    };
</script>

<style lang="less" scoped>
	.usdt_wrap{
		width: 100%;
		height: 100%;
		position: absolute;
	}
	.red_top_bg{

	}
	.button_box{
		width: 90%;
		margin-left: 5%;
		height: 30px;
		background: #ebedf0;
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
		margin-top: -10px;
		display: flex;
		text-align: center;
		.copy_link{
			width: 100%;
			line-height: 30px;
		}
	}
    .code_box {
        width: 90%;
		margin-left: 5%;
        padding: 5px 0;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
        border-radius: 6px;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
		.money{
			color: #000;
			font-size: 26px;
		}
		.wallet{
			margin-top: 10px;
		}
		.walletAddress{
			text-align: center;
			color: #000;
			width: 80%;
		}
		div{
			color: #999;
			font-size: 14px;
			margin-bottom: 15px;
		}
        .qrcode_img{
        	width: 200px;
        	height: 200px;
        	margin: 0 auto;
			text-align: center;
        	background: linear-gradient(to left, #999, #999) left top no-repeat, 
        				linear-gradient(to bottom, #999, #999) left top no-repeat, 
        				linear-gradient(to left, #999, #999) right top no-repeat,
        				linear-gradient(to bottom, #999, #999) right top no-repeat, 
        				linear-gradient(to left, #999, #999) left bottom no-repeat,
        				linear-gradient(to bottom, #999, #999) left bottom no-repeat,
        				linear-gradient(to left, #999, #999) right bottom no-repeat,
        				linear-gradient(to left, #999, #999) right bottom no-repeat;
        	background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px; 
        	span{
        		line-height: 220px;
        	}
        	img{
        		width: 190px;
        		height: 190px;
        		margin-top: 5px;
        	}
        }

        p {
            font-size: 15px;
            line-height: 21px;
            color: #000;
            font-weight: bold;
            margin-top: 13px;
        }
		.address_left{
			width: 90%;
			text-align: left;
		}
    }

    .warming {
        margin-top: 17px;
        padding: 0 14px;

        .tit {
            font-size: 14px;
            color: rgba(0,0,0,.8);
            line-height: 20px;
            font-weight: bold;
        }

        .content {
            font-size: 12px;
            color: rgba(0,0,0,.6);
            line-height: 17px;
            margin-top: 9px;
        }
    }

    .basic_btn {
        margin: 30px auto 0 auto;
    }
	/deep/ .van-cell{
		width: 90%;
		margin-left: 5%;
		margin-top: 10px;
		border-radius: 6px;
	}
	/deep/ .van-uploader{
		margin-left: 50%;
	}

	.qrcode{
    display: inline-block;
    img {
        width: 132px;
        height: 132px;
        background-color: #fff; //设置白色背景色
        padding: 6px; // 利用padding的特性，挤出白边
        box-sizing: border-box;
    }
}
	.canal_tips {
        padding: 10px 16px 1px 16px;
        line-height: 17px;
        font-size: 12px;
        color: #f12211;
    }
</style>
